import i18n from '../../lib/utils/i18n';

export const plantsOptions = [
  { label: i18n.t('waterQuantities.WATER_SYSTEM'), value: 'WATER_SYSTEM' },
  { label: i18n.t('assetLabels.typeOptions.PUBLIC_WATER_TREATMENT_PLANT'), value: 'CLEAN_WATER_TREATMENT_PLANT_REPORT' }, // eslint-disable-line max-len
  { label: i18n.t('sedimentsLabels.fields.plantName'), value: 'WASTE_WATER_TREATMENT_PLANT_REPORT' },
];
